(function () {
  function initPopularProductsSliders() {
    document.querySelectorAll('.popular-products__content--slider').forEach(function (content) {
      var track = content.querySelector('.popular-products__slider');
      if (!track || track.dataset.sliderInitialized) return;
      track.dataset.sliderInitialized = 'true';

      var columns = parseInt(track.dataset.columns, 10) || 4;
      var prevEl = content.querySelector('.popular-products__arrow--prev');
      var nextEl = content.querySelector('.popular-products__arrow--next');

      var swiper = new Swiper(track, {
        // Clean 2-up view on phones (was 1.4 -- showed one full card plus a
        // sliver of the next, not a real 2-column layout).
        slidesPerView: 2,
        spaceBetween: 16,
        initialSlide: 0,
        navigation: { nextEl: nextEl, prevEl: prevEl },
        // Auto-advance one product to the left every 3s; disableOnInteraction:
        // false keeps it running after the visitor manually uses the
        // prev/next arrows instead of permanently stopping it on first touch.
        // (No pauseOnMouseEnter -- matches product-slider.js's autoplay
        // config elsewhere in the theme, and avoids it getting stuck paused
        // if the cursor is left resting over the slider.)
        autoplay: { delay: 3000, disableOnInteraction: false },
        breakpoints: {
          750: { slidesPerView: 3, spaceBetween: 24 },
          990: { slidesPerView: columns, spaceBetween: 24 }
        }
      });

      var updateEdgeClasses = function () {
        content.classList.toggle('is-beginning', swiper.isBeginning);
        content.classList.toggle('is-end', swiper.isEnd);
      };
      swiper.on('slideChange', updateEdgeClasses);
      swiper.on('resize', updateEdgeClasses);
      updateEdgeClasses();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopularProductsSliders);
  } else {
    initPopularProductsSliders();
  }
  document.addEventListener('shopify:section:load', initPopularProductsSliders);
})();
